import styled from "@emotion/styled";
import { Box } from "@mui/material";
import VideoPlayer from 'react-video-js-player';
// import ReactPlayer from 'react-player/lazy'
export const Section = styled('section')(({ theme }) => (props) => ({
    padding: '80px  96px  ',
    background: '#ebf1fb',
    [theme.breakpoints.down('md')]: {
        padding: '48px  '
    },
    [theme.breakpoints.down('sm')]: {
        padding: '16px 24px 0px '
    },
}))

export const Heading = styled('h4')(({ theme }) => (props) => ({
    fontSize: "24px",
    fontWeight: "800",
    lineHeight: "0 0 18px",
    margin: '0',
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary
}))
export const ContentSection = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // background: theme.palette.mode === "light" ? theme.palette.background.lightSecondary : theme.palette.background.darkSecondary,
    [theme.breakpoints.down('lg')]: {
        flexDirection: "column",

    },

}))
export const TextSection = styled('div')(({ theme }) => (props) => ({
    flex: 1,
    // height: props.loading ? "288px" : 'auto',
    boxSizing: 'border-box',
    margin:'0',
    [theme.breakpoints.down('lg')]: {
        height: 'auto'
    },
    [theme.breakpoints.down('md')]: {
        // maxHeight: '60vh',
        height: 'auto'
    },

}))
export const HeadingText = styled('h5')(({ theme }) => (props) => ({
    fontSize: "20px",
    fontWeight: "700",
    lineHeight: "29px",
    margin: '0',
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    width: '90%',
    [theme.breakpoints.down('sm')]: {
        fontSize: '18px'
    }
}))
export const HeadingTextBlue = styled('span')(({ theme }) => (props) => ({
    fontSize: "20px",
    fontWeight: "700",
    lineHeight: "29px",
    color: theme.palette.primary.main,
    margin: '0 5px',
    [theme.breakpoints.down('sm')]: {
        fontSize: '18px'
    }
}))
export const TextParagraph = styled('div')(({ theme }) => (props) => ({
    "& > p": {
        fontSize: "15px",
        fontWeight: "400",
        lineHeight: '1.5',
        textAlign: 'justify',
        color: theme.palette.mode === "light" ? theme.palette.text.light : theme.palette.text.dark,
        width: '95%',
        [theme.breakpoints.down('lg')]: {
            width: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
            width: '95%',
        }
    },
    "& > h2": {
        fontSize: "24px",
        fontWeight: "800",
        lineHeight: "29px",
        margin: '0',
        color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSeco
    }

}))
export const VideoSection = styled('div')(({ theme }) => (props) => ({
    width: '45%',
    maxHeight: '288px',
    minHeight: '288px',
    background: props.loading ? theme.palette.mode === "light" ? theme.palette.background.lightSecondary : theme.palette.background.darkSecondary : "transparent",
    [theme.breakpoints.down('md')]: {
        width: '100%',
        height: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: 'auto',
        minHeight: 'auto',
    }
}))
export const VideoPlay = styled(Box)(({ theme }) => (props) => ({
    width: '548px',
    height: '300px',
    borderRadius: '10px',
    backgroundSize: 'cover',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
        width: '95vw',
        margin: '30px 0'
    },
    [theme.breakpoints.up('md')]: {
        '&::before': {
            backgroundColor: '#0056D2',
            content: '""',
            position: 'absolute',
            top: "-16px",
            right: "-16px",
            width: '100px',
            height: '100px',
            borderRadius: '10%',
            zIndex: -1,
        },
        '&::after': {
            backgroundColor: '#0056D2',
            content: '""',
            position: 'absolute',
            bottom: "-16px",
            left: "-16px",
            width: '150px',
            height: '150px',
            borderRadius: '10%',
            zIndex: -1,
        }
    }
    ,
    [theme.breakpoints.down('sm')]: {
        '&::before': {
            backgroundColor: '#0056D2',
            content: '""',
            position: 'absolute',
            top: "-8px",
            right: "-8px",
            width: '70px',
            height: '70px',
            borderRadius: '10%',
            zIndex: -1,
        },
        '&::after': {
            backgroundColor: '#0056D2',
            content: '""',
            position: 'absolute',
            bottom: "-8px",
            left: "-8px",
            width: '120px',
            height: '120px',
            borderRadius: '10%',
            zIndex: -1,
        },
        width: '85vw',
        height: '220px',
    },



    // "& .vjs-poster ": {
    //     backgroundSize: 'cover',
    // }
}))
